/* eslint-disable import/prefer-default-export */

import React, { useMemo, useState } from 'react';

import AntCheckbox from 'antd/lib/checkbox';

import Admin from 'hive-admin/src/components/Admin';
import ActionWithRequest from 'hive-admin/src/components/ActionWithRequest';

function PopconfirmFields({ fields, children }) {
  const fieldsValuesInitial = useMemo(
    () => fields.reduce(
      (agr, name) => {
        agr[name] = false;
        return agr;
      },
      {},
    ),
    [fields],
  );
  const [fieldsValues, setFieldsValues] = useState(fieldsValuesInitial);
  const fieldsAllChecked = useMemo(
    () => !fields.find(([name]) => !fieldsValues[name]),
    [fields, fieldsValues],
  );
  return (
    <div>
      {children}
      <p key="all">
        <AntCheckbox
          size="small"
          checked={!!fieldsAllChecked}
          onChange={(event) => {
            if (event.target.checked) {
              setFieldsValues(fields.reduce(
                (agr, [name]) => {
                  agr[name] = true;
                  return agr;
                },
                {},
              ));
            } else {
              setFieldsValues({});
            }
          }}
        />
        &nbsp;
        &nbsp;
        All
      </p>
      {fields.map(([name, label]) => (
        <p key={name}>
          <AntCheckbox
            size="small"
            data-populate-fields-from-target-field-name={name}
            checked={fieldsValues[name]}
            onChange={event => setFieldsValues({
              ...fieldsValues,
              [name]: !!event.target.checked,
            })}
          />
          &nbsp;
          &nbsp;
          {label}
        </p>
      ))}
    </div>
  );
}

Admin.addToLibrary(
  'ActionPopulateFieldsFromTarget',
  config => ActionWithRequest.create({
    isDivider: true,
    virtual: [() => true],
    targetFieldName: null,
    targetFields: [],
    targetPopconfirmDescription: <p>Fields:</p>,
    getTargetPopconfirmDescription: props => props.targetPopconfirmDescription,
    popconfirm: (props) => ({
      title: (
        <PopconfirmFields
          fields={props.targetFields}
        >
          {props.getTargetPopconfirmDescription(props) || null}
        </PopconfirmFields>
      ),
    }),
    getRequestConfig: props => ({
      url: `${props.targetUrlPrefix}/${props.form.getFieldValue(
        props.targetFieldName,
      )}`,
      method: 'get',
    }),
    handleSuccess: (data, props) => {
      const updates = {};
      props.targetFields.forEach(([name]) => {
        const input = document.querySelector(
          `input[data-populate-fields-from-target-field-name="${name}"]`,
        );
        if (input && input.checked) {
          updates[name] = {
            value: data[name],
            touched: true,
          };
        }
      });
      props.form.setFields(updates);
    },
    style: { width: '100%', marginBottom: '15px' },
    ...config,
  }));

  export function createFieldsRegister() {
    const fields = [];
    const add = (field, defaultLabel) => {
      field = Array.isArray(field) ? Admin.compileFromLibrary(field) : field;
      fields.push([
        field.name,
        field.label || defaultLabel || null,
      ]);
      return field;
    };
    return { fields, add };
  }
